import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IParamsGetCommonSearch } from '~/utils/interface/commonField';

const commonSearchApi = {
  getCommonSearch(params: IParamsGetCommonSearch) {
    const url = `api/admin/common-search`;
    return axiosClient.get<IApiBaseResponse<any>>(url, { params });
  },
};

export default commonSearchApi;
